import { AggregateTimeFilter, TimeAggregationType } from 'lib/graphql/graphql';
import { DateTime } from 'luxon';
import useEvent from 'providers/event/useEvent';
import { useMemo } from 'react';

function useAggregateFilter(selectedTime: string) {
  const { timezone } = useEvent();

  return useMemo<AggregateTimeFilter | undefined>(() => {
    const now = DateTime.now().setZone(timezone);
    if (selectedTime === 'preset#today') {
      return { time: now.startOf('day').toISO()!, type: TimeAggregationType.Day };
    }
    if (selectedTime === 'preset#yesterday') {
      return { time: now.minus({ day: 1 }).startOf('day').toISO()!, type: TimeAggregationType.Day };
    }
    if (selectedTime === 'preset#last_week') {
      return { time: now.startOf('week').toISO()!, type: TimeAggregationType.Week };
    }
    if (selectedTime.startsWith('month#')) {
      const time = selectedTime.split('#')[1];
      return { time, type: TimeAggregationType.Month };
    }
    return undefined;
  }, [selectedTime, timezone]);
}

export default useAggregateFilter;
